



















import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
})
export default class ErrorPage extends Vue {
    public error: any = {};

    public mounted() {
        this.error = this.$route.query.msg;
    }
}
